export const isEmpty = o =>
  Object.keys(o).length === 0 && o.constructor === Object
